import React from 'react';
import { useServicesContext, useClientServerUtils } from '@oneaudi/vtp-shared';
import { TrackingServiceV2 } from '@oneaudi/audi-tracking-service';
import { trackFeatureAppReady } from '../../tracking/tilesTracking';
import { ContentService } from '@oneaudi/content-service';
import Favorites from './Favorites';
import Results from './Results';
import { SELECTORS } from '@oneaudi/stck-store';
import { useSelector } from 'react-redux';
import { TilesSkeleton } from './Skeleton/TilesSkeleton';

interface TilesWrapperProps {}
const TilesWrapper: React.FC<TilesWrapperProps> = () => {
  const servicesContext = useServicesContext();
  const isLoading = useSelector((state) => SELECTORS.UI.getLoadingState(state));
  const audiContentService = servicesContext.getAdditionalService(
    'audi-content-service'
  ) as ContentService;
  const content = audiContentService.getContent();
  const sortingConfiguration = content.fields.sortingParameters;

  const appContext: 'favorites' | 'results' = content.fields.appContext || 'results';

  const sortParam: string =
    sortingConfiguration?.defaultOption ||
    sortingConfiguration?.options?.[0] ||
    'prices.retail:asc';

  const { isClient } = useClientServerUtils();

  const trackingService = useServicesContext().getAdditionalService(
    'audi-tracking-service'
  ) as TrackingServiceV2;
  React.useEffect(() => {
    trackFeatureAppReady(trackingService, sortParam);
  }, []);

  const renderClient = isClient && !isLoading;

  if (renderClient) {
    // Client
    return appContext === 'favorites' ? <Favorites /> : <Results />;
  }

  // SSR: skeleton
  return <TilesSkeleton />;
};

export default TilesWrapper;
